import modalStyles from "../../modals.module.scss"
import commonOnboardingStyles from "../common.module.scss"
import { TypographyH2, TypographyP } from "@/components/ui/typography"
import { Button } from "@/components/ui/button"
import { OnboardingStep, useOnboardingStore } from "../model"
import { ArrowLeft } from "lucide-react"

import { useMutation } from "@tanstack/react-query"
import {
  type SetMyOptionsDtoReq,
  userControllerSetMyOptions,
} from "@/shared/api/generated"
import { useAutoTranslation, useModalStore, useOptionsStore } from "@/entities"
import { Modal } from "@/shared/types"
import { toast } from "sonner"
import { VOICES } from "@/shared/constants/voices"
import { SelectVoiceItem } from "@/features"
import { DISCOVERED_TRANSLATION_KEYS, LANG_KEYS } from "@/shared/constants"

export const OnboardingModalSelectVoice = () => {
  const { t } = useAutoTranslation()
  const selectedLanguage = useOnboardingStore(s => s.selectedLanguage)
  const selectedVoice = useOnboardingStore(s => s.selectedVoice)
  const setSelectedVoice = useOnboardingStore(s => s.setSelectedVoice)
  const closeModal = useModalStore(s => s.closeModal)

  const setOptionsMutation = useMutation({
    mutationFn: (dto: SetMyOptionsDtoReq) => userControllerSetMyOptions(dto),
    onSuccess: newOptions => {
      useOptionsStore.getState().setData(newOptions)
      closeModal(Modal.ONBOARDING)
      toast.success(t(DISCOVERED_TRANSLATION_KEYS.VOICE_SELECTED_SUCCESSFULLY))
    },
  })

  const handleBack = () => {
    const store = useOnboardingStore.getState()
    store.setSelectedVoice(null)
    store.setSelectedLanguage(null)
    store.setStep(OnboardingStep.SELECT_LANGUAGE)
  }

  const handleSubmit = () => {
    if (!selectedVoice || !selectedLanguage) return
    setOptionsMutation.mutate({
      voiceId: selectedVoice,
      voiceLang: selectedLanguage,
      markWebOnboardingAsCompleted: true,
    })
  }

  if (!selectedLanguage) {
    return null
  }

  return (
    <div className={modalStyles.backdrop}>
      <div className={commonOnboardingStyles.wrapper}>
        <div className={commonOnboardingStyles.card}>
          <div className={commonOnboardingStyles.card__header}>
            <button
              onClick={handleBack}
              type="button"
              className="mb-2 cursor-pointer hover:opacity-80"
            >
              <ArrowLeft />
            </button>
            <TypographyH2>
              {t(
                DISCOVERED_TRANSLATION_KEYS.NOW_FOR_THE_FUN_PART_LET_SPICK_AVOICE
              )}
            </TypographyH2>
            <TypographyP className="mt-0">
              {t(
                DISCOVERED_TRANSLATION_KEYS.CHOOSE_WHICH_AI_VOICE_YOU_DLIKE_FOR_YOUR_GENERATED_AUDIO_YOU_CAN_ALWAYS_CHANGE_IT_LATER_IN_SETTINGS
              )}
            </TypographyP>
          </div>

          <div className={commonOnboardingStyles.card__content}>
            {VOICES[selectedLanguage].map(voice => (
              <SelectVoiceItem
                key={`SELECT_VOICE_${voice.id}`}
                {...voice}
                isActive={selectedVoice === voice.id}
                onSelectVoice={() => setSelectedVoice(voice.id)}
              />
            ))}
          </div>

          <div className={commonOnboardingStyles.card__footer}>
            <Button
              className="w-full"
              disabled={!selectedVoice}
              onClick={handleSubmit}
            >
              {t(LANG_KEYS.START_LISTENING)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
